import type { SceneStats as GameStats } from '../game/scene';

/** ?debug in the URL shows fps, draw calls and pixel ratio, refreshed twice a second. */
export function mountDebugOverlay(stats: GameStats): void {
  if (!new URLSearchParams(location.search).has('debug')) return;
  const el = document.createElement('div');
  el.className = 'debug-overlay';
  document.body.appendChild(el);
  setInterval(() => {
    el.textContent = `${stats.fps.toFixed(0)} fps, ${stats.drawCalls} calls, ${stats.pixelRatio.toFixed(2)}x`;
  }, 500);
}
